module.exports = __webpack_public_path__ + "static/media/aroldo-sorrindo-esquerda.880ba6f9.svg";